const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tabletS: '550px',
  tablet: '768px',
  laptopS: '900px',
  laptop: '992px',
  laptopL: '1200px',
  desktop: '1400px',
  desktopL: '1600px'
};

const minSizes = {
  laptop: '993px'
};

export const device = {
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  tabletS: `(max-width: ${size.tabletS})`,
  tablet: `(max-width: ${size.tablet})`,
  laptopS: `(max-width: ${size.laptopS})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopL: `(max-width: ${size.laptopL})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktopL})`,
  minLaptop: `(min-width: ${minSizes.laptop})`,
  tabletHeight: `(max-height: ${size.tablet})`,
};

export const vertical = {
  small: '(max-height: 480px)',
  medium: '(max-height: 800px)',
  large: '(max-height: 960px)'
};
